export const HTTP_HEADER = {
    FINGERPRINT: 'x-fingerprint',
    /**
     * Cloudflare Turnstile token for public-form endpoints — the tRPC context verifies it via
     * Turnstile siteverify and exposes the result through the `ctx.captcha` gate (see
     * server/src/utils/auth/turnstile.ts `validateTurnstileForPublicForm`).
     */
    TURNSTILE_TOKEN: 'x-turnstile-token',
    USER_TIMEZONE: 'x-user-timezone',
    PAGE_URL: 'x-page-url',
    AUTHORIZATION: 'authorization',
    USER_AGENT: 'user-agent',
    DEBUG_INFO: 'x-debug-info',
    ORG_ID: 'x-curium-org-id',
    /**
     * Shared secret injected by Cloudflare (a "set" request-header Transform Rule) on every
     * proxied request. The origin-verify guard rejects requests whose value does not match
     * `ORIGIN_VERIFY_SECRET`, forcing all public traffic through Cloudflare and closing the
     * `*.ondigitalocean.app` origin bypass. See server/src/config/origin-verify.ts.
     */
    ORIGIN_VERIFY: 'x-origin-verify',
    /** Original peer address observed and set by DigitalOcean App Platform. */
    DIGITALOCEAN_CONNECTING_IP: 'do-connecting-ip',
    /** Original visitor address set by Cloudflare and trusted only through an authenticated proxy path. */
    CLOUDFLARE_CONNECTING_IP: 'cf-connecting-ip',
    /**
     * Local-dev-only. Carries a user email for the dev auth bypass (see
     * server/src/utils/auth/dev-auth.ts). Honoured only when DEV_AUTH_BYPASS_ENABLED=true
     * and NODE_ENV=development; ignored everywhere else.
     */
    DEV_AUTH_EMAIL: 'x-dev-auth-email',
    /**
     * Test-environment only. Proves the caller holds `E2E_LIFECYCLE_SECRET` — the same shared
     * secret that authorises the e2e-lifecycle API — on request paths that are not routed
     * through that controller. Honoured only when `E2E_LIFECYCLE_SECRET` is set and NODE_ENV is
     * exactly `development`, `test` or `staging` (server/src/utils/auth/turnstile-test-keys.ts).
     */
    E2E_SECRET: 'x-e2e-secret',
    /**
     * Test-lane only. Selects a Cloudflare Turnstile *test* secret key so an automated suite can
     * drive the challenge deterministically — `pass`, `fail` or `spent`. Honoured only in exactly
     * `development`, `test` or `staging` and alongside a valid {@link HTTP_HEADER.E2E_SECRET}; see
     * server/src/utils/auth/turnstile-test-keys.ts.
     */
    E2E_TURNSTILE_MODE: 'x-e2e-turnstile-mode',
} as const;

export type HttpHeader = (typeof HTTP_HEADER)[keyof typeof HTTP_HEADER];
